import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db37b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_4 = { class: "fw_600 mb-2 d-block" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "fw_700 mb-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted mb-3"
}
const _hoisted_9 = {
  key: 0,
  class: "card p-3 mb-3"
}
const _hoisted_10 = { class: "d-flex align-items-start mb-2" }
const _hoisted_11 = { class: "fw_600" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "fs_14 text-muted ms-2"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "mb-0 fst-italic" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "mt-2 ps-3 border-start"
}
const _hoisted_21 = { class: "fs_14 fw_600 d-block" }
const _hoisted_22 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_23 = {
  key: 0,
  class: "fs_14 text-muted ms-2"
}
const _hoisted_24 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_25 = { class: "mb-0 fs_14 fst-italic" }
const _hoisted_26 = { class: "d-flex align-items-center justify-content-center mt-4 mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Survey Results",
        text: "Survey Results",
        class: "mb-0"
      })
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.submittedFactories.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Select Production Site",
                    text: "Select Production Site"
                  })
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  style: {"max-width":"400px"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFactoryId) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFactoryChange()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submittedFactories, (fs) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: fs.factoryId,
                      value: fs.factoryId
                    }, _toDisplayString(fs.name), 9, _hoisted_5))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedFactoryId]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.response)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.template.sections, (section, si) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-4",
                    key: section.sectionId
                  }, [
                    _createElementVNode("h5", _hoisted_7, _toDisplayString(si + 1) + ". " + _toDisplayString(_ctx.getLocalized(section.title)), 1),
                    (_ctx.getLocalized(section.description))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.getLocalized(section.description)), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.questions, (question) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: question.questionId
                      }, [
                        (_ctx.isQuestionVisible(question))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getLocalized(question.text)), 1)
                              ]),
                              (question.subQuestions.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    (question.questionType === 0 || question.questionType === 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["answerBadge", _ctx.getAnswerClass(_ctx.getAnswerValue(question.questionId, ''))])
                                          }, _toDisplayString(_ctx.getAnswerValue(question.questionId, '') || '-'), 3),
                                          (_ctx.getAnswerEvidence(question.questionId, ''))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                _createVNode(_component_localized_text, {
                                                  localizedKey: "Evidence available",
                                                  text: "Evidence available"
                                                })
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (question.questionType === 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.getAnswerInfo(question.questionId, '') || '-'), 1)
                                          ]))
                                        : (question.questionType === 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.certificationOptions, (cert) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: cert.certificationId
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["fs_14", _ctx.getCertSelected(question.questionId, cert.certificationId) ? 'fw_600' : 'text-muted'])
                                                  }, [
                                                    (_ctx.getCertSelected(question.questionId, cert.certificationId))
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "✓"))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_19, "✗")),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.getLocalized(cert.name)), 1)
                                                  ], 2)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (question.subQuestions.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.subQuestions, (sub) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "mb-2",
                                        key: sub.subQuestionId
                                      }, [
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getLocalized(sub.text)), 1),
                                        (sub.questionType === 0 || sub.questionType === 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["answerBadge", _ctx.getAnswerClass(_ctx.getAnswerValue(question.questionId, sub.subQuestionId))])
                                              }, _toDisplayString(_ctx.getAnswerValue(question.questionId, sub.subQuestionId) || '-'), 3),
                                              (_ctx.getAnswerEvidence(question.questionId, sub.subQuestionId))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                                    _createVNode(_component_localized_text, {
                                                      localizedKey: "Evidence available",
                                                      text: "Evidence available"
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (sub.questionType === 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.getAnswerInfo(question.questionId, sub.subQuestionId) || '-'), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/provider')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Back to Dashboard",
                text: "Back to Dashboard"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}